/** PYTANIA DO FAQ */

export const ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS: FaqBlockQuestion[] = [
  {
    elementQuestion: "1. Ile trwa założenie spółki zoo?",
    elementAnswer: "W zależności od regionu Polski, procedura założenia spółki w systemie S24 od jej rozpoczęcia do momentu wpisu w KRS trwa zazwyczaj od 6 do 10 dni roboczych."
  },
  {
    elementQuestion: "2. Czy można otrzymać fakturę za usługę założenia spółki zoo?",
    elementAnswer: "Tak, za przeprowadzenie rejestracji spółki otrzymują Państwo fakturę VAT."
  },
  {
    elementQuestion: "3. Czy otrzymaną fakturę można wliczyć w koszty?",
    elementAnswer: "Tak, otrzymaną fakturę można wliczyć w koszty uzyskania przychodu."
  },
  {
    elementQuestion: "4. Kto może być udziałowcem w firmie?",
    elementAnswer: [
      "W przypadku mikro sp. z o.o., patrząc z perspektywy uproszczeń rozliczeniowych i podatkowych, najkorzystniejszym przypadkiem jest gdy udziałowcem jest osoba fizyczna.",
      "Więcej informacji można odleźć również dziale II pkt 1 wpisu na naszej bazie wiedzy."
    ],
    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000307874-czym-jest-sp-z-o-o-oraz-jak-j%C4%85-zorganizowa%C4%87-informacje-og%C3%B3lne"
  },
  {
    elementQuestion: "5. Co z ZUS?",
    elementAnswer: "Wspólnicy spółki z o.o., której struktura właścicielska jest dwu lub ponad dwuosobowa, nie podlegają ZUS. Dany stan rzeczy wynika z braku objęcia obowiązkiem ZUS wspólników w art. 8 ust. 6 ustawy o systemie ubezpieczeń społecznych."
  },
  {
    elementQuestion: "6. Gdzie może być siedziba firmy?",
    elementAnswer: "Siedzibą spółki jest miejscowość. Siedziba spółki może znajdować się w miejscu  zamieszkania - w domu, w lokalu w mieszkaniu, ale też w przestrzeniach wynajmowanych."
  },
  {
    elementQuestion: "7. Jakie są obowiązki związane z rejestracją spółki z o.o.??",
    elementAnswer: [
      "Wraz z rejestracją podmiotu niezbędne jest przygotowanie dokumentacji składanej do Urzędu Skarbowego. Co do zasady są to następujące dokumenty: NIP-8, PCC-3 oraz ewentualnie VAT-R w przypadku rejestracji podmiotu w rejestrze VAT jako \"czynny podatnik VAT\" albo dla celów VATu europejskiego. ",
      "Niezbędne jest również przygotowanie umowy najmu lokalu oraz zgłoszenie spółki do CRBR."
    ],
    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000278880-najem-lokalu-dla-sp%C3%B3%C5%82ki-z-o-o-"
  }
];

export const CENNIK_PAGE_FAQ_QUESTIONS: FaqBlockQuestion[] = [
  {
    elementQuestion: "1. Czy możliwe jest przetestowanie aplikacji przed wykupieniem płatnego pakietu?",
    elementAnswer: "Tak, każdy Użytkownik może skorzystać z bezpłatnego miesięcznego okresu testowego. Oznacza to, że przez miesiąc Użytkownik może bezpłatnie korzystać z pełnej funkcjonalności aplikacji."
  },
  {
    elementQuestion: "2. Co się dzieje po wygaśnięciu okresu testowego?",
    elementAnswer: "Po wygaśnięciu okresu testowego konto przechodzi w stan spoczynku. Oznacza to, że jego funkcjonalność zostaje zredukowana jedynie do bezpłatnej funkcjonalności, którą jest wystawianie faktur sprzedażowych."
  },
  {
    elementQuestion: "3. Czy płatny pakiet umożliwia samodzielne prowadzenie pełnej księgowości online?",
    elementAnswer: [
      "Tak, każdy pakiet premium wystarcza do prowadzenia pełnej księgowości online mikro sp. z o.o. Niniejsze narzędzie umożliwia bardzo łatwe rozliczenie niewielkich podmiotów sp. z o.o. których działąlność występuje na terytorium Rzeczypospolitej o charakterze usługowym lub handlowym",
      "Ponad 95% Podatników prowadzących swoje rozliczenie w księgowości Fakturomanii to mali podatnicy, których statystyczne rozliczenie oscyluje w granicach do 30 dokumentów w ujęciu miesięcznym. Z tego względu księgowość z Fakturomanią jest optymalizowana właśnie pod kątem takiej wielkości działalności, tak aby każdy mógł w sposób przystępny i prosty rozliczyć taką mikro sp. z o.o.",
      "System nie jest jednak odpowiedni dla działalności o charakterze produkcyjnym, deweloperskim, transgranicznym lub inwestycyjnym. Z uwagi też na dedykację dla podstawowego obrotu krajowego, w systemie nie są wspierane transakcje o charakterze walutowym lub przynależnym do zysków kapitałowych (np. inwestycje w obrót kryptowalutami, papierami wartościowymi, akcjami, udziałami, zyskami z osób prawnych - przychodów, o których mowa m.in. w art. 7b ustwawy z dnia 15 lutego 1992 o podatku dochodowym od osób prawnych).",
      "System nie jest również odpowiedni dla podmiotów, które posiadają udziały w innych osobach prawnych lub wspólnikami są osoby prawne, lub w których występują transakcje transgraniczne w tym podlegające procedurze OSS lub IOSS za wyjątkiem sporadycznych transakcji zakupowych WNT lub importu usług. Taki typ działalności warto jest powierzyć prowadzeniu przez biuro rachunkowe z uwagi na jego znaczne skomplikowanie."
    ]
  },
  {
    elementQuestion: "4. Co się dzieje po wygaśnięciu pakietu płatnego?",
    elementAnswer: "Po wygaśnięciu pakietu płatnego funkcjonalność konta zostaje ograniczona do przeglądania wygenerowanych uprzednio dokumentów oraz konto zamienia się w konto dla bezpłatnej funcjonalności."
  },
  {
    elementQuestion: "5. Czy dla Użytkownika jest możliwość uzyskania pomocy księgowego?",
    elementAnswer: "W przypadku zdecydowania się na korzystanie z Fakturomanii, w godzinach od 10 do 16, w przypadku pytań lub wątpliwości nasi księgowi są do Państwa dyspozycji. Jeżeli zatem pojawiają się pytania dotyczące aplikacji, księgowości lub spółek zoo - zachęcamy do kontaktu przez czat, mailowo lub telefonicznie, zawsze udzielamy Państwu wsparcia."
  },
  {
    elementQuestion: "6. Czy dostęp do doradcy księgowego zawiera się w pakiecie bezpłatnym?",
    elementAnswer: "W przypadku pakietu bezpłatnego zespół wsparcia Fakturomanii zawsze udzieli Państwu pomocy z zakresu obsługi technicznej aplikacji."
  },
  {
    elementQuestion: "7. Czy jeśli wykupię dostęp do aplikacji, będę związany umową na czas określony? Czy są jakieś kary umowne lub odsetki?",
    elementAnswer: "Wykupienie dostępu do aplikacji skutkuje zawiązaniem umowy drogą elektroniczną na czas oznaczony odpowiadający wybranemu pakietowi. Brak jest kar umownych lub odsetek, w każdej chwili mogą Państwo zrezygnować z usług serwisu Fakturomania. W przypadku rezygnacji z serwisu kwota za niewykorzystany czas abonamentu nie podlega jednak zwrotowi."
  },
  {
    elementQuestion: "8. Czy aplikacja Fakturomanii jest skierowana do działalności gospodarczej osób fizycznych?",
    elementAnswer: [
      "Aplikacja Fakturomanii jest dedykowana wyłącznie dla osób prawnych - mikro sp. z o.o.",
    ]
  }
];

export const FAQ_PAGE_FAQ_QUESTIONS: FaqBlockQuestion[] = [
  {
    elementQuestion: "1. Czym jest Fakturomania?",
    elementAnswer: [
      "Fakturomania to aplikacja webowa służąca prowadzeniu pełnej księgowości online.",
      "Nasze rozwiązanie skierowane jest do mikro spółek z ograniczoną odpowiedzialnością prowadzących działalność gospodarczą na terytorium Polski.",
      "Jeśli chcesz prowadzić własną firmę, ale obawiasz się wysokich kosztów związanych z jej prowadzeniem – Fakturomania może być dobrym rozwiązaniem."
    ]
  },
  {
    elementQuestion: "2. Czym jest pełna księgowość online?",
    elementAnswer: "Pełna księgowość to rozbudowany, precyzyjny i dokładny system ewidencji zdarzeń gospodarczych, będący częścią Rachunkowości. Służy on do kontroli, analizy i generowania informacji na temat sytuacji firmy w danym momencie lub na przestrzeni pewnego okresu."
  },
  {
    elementQuestion: "3. Czy Fakturomania wymaga specjalistycznej wiedzy księgowej?",
    elementAnswer: [
      "Nie, rozliczenia w Fakturomanii nie wymagają posiadania specjalistycznej wiedzy księgowej. Do korzystania z aplikacji wystarczy połączenie z internetem, przeglądarka internetowa, systematyczność oraz skrupulatność.",
      "Obsługa aplikacji została na tyle uproszczona, aby każdy był w stanie poprowadzić pełną księgowość mikro spółek zoo. W razie jakichkolwiek wątpliwości zawsze służymy pomocą.",
      "Fakturomania to również bogata baza wiedzy omawiająca zagadnienia związane z księgowością, podatkami i samą spółką z o.o."
    ]
  },
  {
    elementQuestion: "4. Dla kogo przeznaczona jest aplikacja?",
    elementAnswer: "Aplikacja jest dedykowana jednostkom mikro, które prowadzą działalność w formie spółki z o.o. o profilu usługowym, handlowym lub usługowo-handlowym na terytorium Polski."
  },
  {
    elementQuestion: "5. Ile można zyskać, prowadząc firmę w formie spółki z o.o.?",
    elementAnswer: [
      "Dzięki spółce z o.o. zyskać można bardzo wiele, zarówno pod względem znaczącego ograniczenia odpowiedzialności jak i też pod względem oszczędności.",
      "Kwota oszczędności wynosić może od kilku do nawet kilkudziesięciu tysięcy złotych rocznie - w przypadku optymalnego zaplanowania działaności."
    ]
  },
  {
    elementQuestion: "6. Co z ZUS?",
    elementAnswer: "W sytuacji gdy wspólników w spółce jest co najmniej dwóch, to żaden z nich nie podlega obowiązkowi ubezpieczeń społecznych oraz zdrowotnych. Decyzja o dobrowolnym ubezpieczeniu należy do przedsiębiorcy."
  },
  {
    elementQuestion: "7. Co z polityką rachunkowości oraz planem kont?",
    elementAnswer: "Dla Państwa wygody przygotowany został uniwersalny plan kont oraz polityka rachunkowości, które są generowane automatycznie przez aplikację. Dokumenty te wystarczy wydrukować i podpisać."
  }
];


// WEBPACK FOOTER //
// ./src/constants/faq-questions-data.ts